export default __webpack_public_path__ + "static/media/diff_ext.d271be9c.png";